export default __webpack_public_path__ + "static/sensors-bdaf95d530a573f6b0e1f3efa5c4a7b0.png";